import React from 'react';
import { Chip } from '@mui/material';
import {
  AccessibleRounded,
  CastRounded,
  KitchenRounded,
  LocalBarRounded,
  MicExternalOnRounded,
  TvRounded,
  WcRounded,
  CheckCircleOutlineRounded,
  MeetingRoomRounded,
} from '@mui/icons-material';
import { PVNavy } from '@pv/common/colors';

interface AmenityBadgeProps {
  amenity: {
    id: string;
    name: string;
    slug: string;
    description?: string;
    icon?: string;
  };
}

const iconMap: Record<string, any> = {
  'check-circle': CheckCircleOutlineRounded,
  'local-bar-rounded': LocalBarRounded,
  'wc-rounded': WcRounded,
  'accessible-rounded': AccessibleRounded,
  'kitchen-rounded': KitchenRounded,
  'tv-rounded': TvRounded,
  'mic-external-on-rounded': MicExternalOnRounded,
  'cast-rounded': CastRounded,
  'meeting-room-rounded': MeetingRoomRounded,
};

const getIconComponent = (iconName: string) => {
  return iconMap[iconName] || CheckCircleOutlineRounded;
};

export const AmenityBadge: React.FC<AmenityBadgeProps> = ({ amenity }) => {
  const IconComponent = getIconComponent(amenity.icon || 'check-circle');

  return (
    <Chip
      icon={<IconComponent fontSize="small" color={PVNavy} />}
      label={amenity.name}
      variant="outlined"
      title={amenity.description}
      sx={{
        borderColor: PVNavy,
        color: PVNavy,
      }}
    />
  );
};
